import { Avatar as HeroAvatar } from "@heroui/react";
import type { ReactNode } from "react";
import { clsx } from "@/src/common/utils/clsx";
import { getInitials } from "@/src/common/utils/get-initials";

type AvatarSize = "sm" | "md" | "lg" | "xl";

const SIZE_CLASSES: Record<AvatarSize, string> = {
	sm: "size-6",
	md: "size-8",
	lg: "size-10",
	xl: "size-14",
};

const FALLBACK_TEXT_CLASSES: Record<AvatarSize, string> = {
	sm: "text-[9px]",
	md: "text-[11px]",
	lg: "text-[13px]",
	xl: "text-[15px]",
};

interface AvatarProps {
	name?: string;
	initials?: ReactNode;
	src?: string;
	alt?: string;
	size?: AvatarSize;
	className?: string;
}

export function Avatar({ name, initials, src, alt, size = "md", className }: AvatarProps) {
	const fallback = initials ?? getInitials(name ?? null, null);
	return (
		<HeroAvatar className={clsx("font-semibold", SIZE_CLASSES[size], className)}>
			{src ? <HeroAvatar.Image src={src} alt={alt ?? name ?? ""} /> : null}
			<HeroAvatar.Fallback className={clsx("bg-primary-100 text-primary-700 font-semibold", FALLBACK_TEXT_CLASSES[size])}>
				{fallback}
			</HeroAvatar.Fallback>
		</HeroAvatar>
	);
}
